/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtopublishevent3Inputs */

const en_failedtopublishevent3 = /** @type {(inputs: Failedtopublishevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to publish event`)
};

const de_failedtopublishevent3 = /** @type {(inputs: Failedtopublishevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event konnte nicht veröffentlicht werden`)
};

/**
* | output |
* | --- |
* | "Failed to publish event" |
*
* @param {Failedtopublishevent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtopublishevent3 = /** @type {((inputs?: Failedtopublishevent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtopublishevent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtopublishevent3(inputs)
	return de_failedtopublishevent3(inputs)
});
export { failedtopublishevent3 as "failedToPublishEvent" }